exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#rulerHeader[data-v-42fb67fb] {\n  box-sizing: border-box; /* ボーダー幅を無視 */\n  text-align: center;\n  letter-spacing: normal;\n  background-color: white;\n\n  border-top-style: none;\n  border-left-style: none;\n\n  border-bottom-style: solid;\n  border-bottom-width: 2px;\n  border-bottom-color: black;\n\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-right-color: #aaaaaa;\n\n  margin-left: -1px;\n}\n.tlHeaderText[data-v-42fb67fb] {\n  margin: auto;\n  white-space: pre;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-42fb67fb","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/RulerHeader.vue
// module id = 498
// module chunks = 0